<style lang="less">
@import "../../../styles/common.less";
</style>
<template>
  <div class="certList">
<!--    <div class="img-title">
      <img src="@/assets/tip.png" alt='版权登记'/>
      <span>由版权家为你自行上传的作品进行具有法律效力的版权存证，版权家不对您上传内容的真实性作验证。</span>
    </div>-->
    <div class="table-list">
      <div class="table-list-title">
        <span style="margin-left:25px">版权存证列表</span>
        <div class="choose-group">
          <span class="choose-group-span">时间</span>
          <Date-picker @on-change="changeDate" :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>
          <span class="choose-group-span">请选择文件类型</span>
          <i-select v-model="model1" style="width:126px" @on-change="selectType">
            <i-option v-for="(item,index) in cityList" :key="index" :value="index">{{ item }}</i-option>
          </i-select>
          <i-input search @on-search="addworkname()" v-model="name" placeholder="请输入作品名称" style="width: 205px" class="select-input-style"></i-input>
          <button class="btn-84" style="margin-right:30px">新增存证</button>
        </div>
      </div>
      <Row class="table-style-size">
        <i-col span="5">存证名称</i-col>
        <i-col span="4">存证数量</i-col>
        <i-col span="4">存证时间</i-col>
        <i-col span="4">存证证书</i-col>
        <i-col span="7">操作</i-col>
      </Row>
      <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
        <i-col span="5" class="notwrap"><Tooltip :content="item.orderTitle" placement="top">{{item.orderTitle}}</Tooltip></i-col>
        <i-col span="4">{{item.attachmentsNum}}</i-col>
        <i-col span="4">{{item.createDate}}</i-col>
        <i-col span="4"><img :src="item.orderAuditStatus=='cert_sign_issue'?ifDciSuccess:ifFciFail" @click="downBookFinish(item.orderAuditStatus,item.orderSeqNo)" :style="{cursor:item.orderAuditStatus=='cert_sign_issue'?'pointer':'default'}" alt='版权登记'/></i-col>
        <!-- <i-col span="7">
          <button class="btn-84" @click="goDetails(item.id)">详情</button> -->
          <!-- <button class="btn-84" @click="goDetails(item.id)">重新提交</button> -->
          <!-- <button class="btn-84" style="margin:0px 20px" @click="downBook(item.orderSeqNo)">下载证书</button>
          <button class="btn-84" style="width:104px" @click="downDataBook(item.orderSeqNo)">下载存证数据包</button>
        </i-col> -->
        <i-col span="7">
            <button class="btn-84" @click="goDetails(item.id)" style="margin-right:20px">详情</button>
            <button v-if="item.orderAuditStatus=='reject_editable'" class="btn-84" @click="goSubmit(item.id)">重新提交</button>
            <div class="showphotow" v-if="item.orderAuditStatus=='cert_sign_issue'">
                <button class="btn-84">更多操作</button>
                <div class="showdiasy">
                    <p @click="downBook(item.orderSeqNo)">下载证书</p>
                    <p @click="downDataBook(item.orderSeqNo)">下载存证包</p>
                    <p @click="downBcBook(item.orderSeqNo)">下载BC文件</p>
                </div>
            </div>
        </i-col>
      </Row>
      <div class="commont-page" style="margin-top:30px">
        <Page :total="total" @on-change="changepage" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pageSize}}页</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrderDownCert,getCertFileType} from '@/api/staticPage';
import Cookies from "js-cookie";
export default {
  metaInfo: {
      title: '存证列表|版权服务专家|版权家',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '存证列表,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "certList",
  data(){
    return{
      total:10,
      pageSize:10,
      pageNumber:1,
      startDate:'',
      endDate:'',
      name:'',
      attachementsTypes:'',
      value2:[],
      cityList: [],
      model1: 'all',
      records:[],
      ifDciSuccess:require('@/assets/cert-open.png'),
      ifFciFail:require('@/assets/cert-close.png'),
    }
  },
  methods: {
    _getCertFileType(){
      let _this = this;
      getCertFileType().then(res=>{
        if(res.code == 200){
          _this.cityList =  Object.assign({'all':'全部'}, res.result)
          console.log('****************',_this.cityList)
        }
      })
    },
    selectType(val){
      console.log('这是获取的类型',val)
      this.attachementsTypes = val;
      this._getOrderDownCert();
    },
    _getOrderDownCert(){
      let _this = this;
      let userInfo = JSON.parse(Cookies.get("userInfo"));
      let params = {
        pageNumber:_this.pageNumber,
        pageSize:_this.pageSize,
        sort:'create_date',
        order:'desc',
        startDate:_this.startDate,
        endDate:_this.endDate,
        name:_this.name,
        attachementsTypes:_this.attachementsTypes,
        registerId:userInfo && userInfo.id?userInfo.id:'',
      }
      getOrderDownCert(params).then((res)=>{
        console.log('获取的最后的实名状态',res)
        if(res.code == 200){
          _this.records = res.result.records
        }
      })
    },
    changeDate(starttime,endtime){
      this.startDate = starttime ? starttime[0]:'';
      this.endDate = starttime ? starttime[1]:'';
      this._getOrderDownCert();
    },
    changepage(index){
      this.pageNumber = index
      this._getOrderDownCert();
    },
    addworkname(){
      this._getOrderDownCert();
    },
    goDetails(id){
      console.log('获取的详情的id',id)
      this.$router.push({
        path: '/cert-info',
        query: {
          id: id
        }
      })
    },
    goSubmit(id){
        this.$router.push({
            path: '/apply-cert',
            query: {
            id: id
            }
        })
    },
    downBookFinish(status,id){
        if(status == 'cert_sign_issue'){
            this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
                if(res.code == 200){
                    // this.funDownload(res.result)
                    window.open(res.result,'_blank')
                }
            })
        }
    },
    downBook(id){
     this.getRequest("/orderCommon/downloadCert/" + id).then(res => {
          if(res.code == 200){
              // this.funDownload(res.result)
              window.open(res.result,'_blank')
          }
      })
    },
    downDataBook(id){
      console.log( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id);
      window.open( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id, '_self');
    },
    downBcBook(id){
        window.open( this.API_ROOT_UPLOAD + "bqjvip/blockChain/tianPing/downloadBc?certificateOrderSeqNos=" + id, '_self');
    },
  },
  mounted(){
    this._getCertFileType();
    this._getOrderDownCert();
  }
};
</script>
<style scoped lang="less">
.showphotow{
    display: inline-block;
    height: 100%;
    position:relative;
    .showdiasy{
      position:absolute;
      top:50px;
      left:0px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgba(179,189,199,.47);
      border-radius: 4px;
      z-index:777;
      width: 110px;
      display:none;
      p{
        height:30px;
        line-height:30px;
        cursor:pointer;
        font-size: 12px;
        background-color: #fff;
        color: #929292;
      }
      p:hover{
        background-color: #f7f9fb;
        color: #4e4e4e;
      }
    }
    &:hover{
      .showdiasy{
        display:block;
      }
    }
  }
</style>

